const formatBytes = (bytes: number, decimals: number, byteLabel: string) => {
  if (!+bytes) return `0 ${byteLabel}`

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = [byteLabel, 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`
}

export { formatBytes }
